import React, { useContext, useEffect, useState } from 'react'
import NavigationBarLayout from '../layouts/NavigationBarLayout'
import PageHeader from '../components/UI/PageHeader'
import SelectDropDown from '../components/UI/SelectDropDown'
import StatCards from '../components/Dashboard/StatCards'
import BarChartCard from '../components/Dashboard/BarChartCard';
import Table from '../components/Table'
import { AppContext } from '../contexts/AppContext'

const DashboardPage = props => {

  const [periodKey, setPeriodKey] = useState('daily');
  const [loading, setLoading] = useState(true);
  const { backendApiCall, currentAgentUID, agentServerData, setCurrentAgentUID } = useContext(AppContext);
  const [statServerData, setStatServerData] = useState(undefined);

  useEffect(() => {
    const fetchStatData = async () => {
      setLoading(true);
      try {
        const resp = await backendApiCall(`/dashboard/get-stat`, {
          period: periodKey,
          agentUID: currentAgentUID
        })
        const respJson = await resp.json();
        console.log("get-stat - res: ", respJson)

        if (!resp.ok)
          throw Error("server error")
        setStatServerData(respJson)
      } catch (e) {
        setStatServerData(null)
        console.log("get-stat - error: ", e)
      }
      setLoading(false);
    }
    if (currentAgentUID && periodKey)
      fetchStatData()
    else if (currentAgentUID === null)
      setLoading(false)
  }, [backendApiCall, periodKey, currentAgentUID])

  return (
    <NavigationBarLayout activeSegment="dashboard">

      <PageHeader title="Dashboard" />

      <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
        {agentServerData?.agentInfo?.availableAgents?.length > 1 && <SelectDropDown options={agentServerData.agentInfo.availableAgents.map(agentUID => {
          return {
            label: agentUID, key: agentUID
          }
        })} currentOptionKey={currentAgentUID} onChange={(k) => { setCurrentAgentUID(k) }} wrapperStyles={{ marginRight: '8px', minWidth: '250px' }} />}

        <SelectDropDown options={[
          { label: 'Daily', key: 'daily' },
          { label: 'Weekly', key: 'weekly' },
        ]} currentOptionKey={periodKey} onChange={(k) => { setPeriodKey(k) }} />
      </div>

      <StatCards cardsData={loading ? null : statServerData?.leadAnalyticsCardData} />

      <BarChartCard title="Lead Analytics" data={loading ? undefined : (statServerData?.leadAnalyticsData || null)} useAccumulatedSumInToolTip={true} />

      <BarChartCard title="Visitor Duration" data={loading ? undefined :( statServerData?.visitorDurationData || null)} />

      <h2 style={{ fontSize: '25px', fontWeight: 400, margin: '46px 0px 25px 0px' }}>Page Analytics</h2>
      {statServerData?.pageAnalyticsData?.header && <Table tableTitles={statServerData?.pageAnalyticsData?.header} rows={statServerData?.pageAnalyticsData?.row} />}

    </NavigationBarLayout >
  )
}

export default DashboardPage